import React, { useState } from "react";
import { DataTable, Pagination } from "@/components/ui";
import { fmtDate } from "@/lib/formatters";
import { Eye } from "lucide-react";

export const ReceivedAmountTable = ({ receipts, onView }) => {
  const [page, setPage] = useState(1);
  const limit = 10;

  const columns = [
    {
      header: "Payment Date",
      accessor: (row) => (
        <div className="text-slate-600 !text-[12px] flex items-center whitespace-nowrap font-medium">
          {row.date ? fmtDate(row.date) : "—"}
        </div>
      ),
      minWidth: "120px",
    },
    {
      header: "SD Id",
      accessor: (row) => {
        const c = row.customer || {};
        return (
          <span className="text-[10px] uppercase tracking-tight whitespace-nowrap text-brand-blue font-medium">
            {c.sdId || "—"}
          </span>
        );
      },
      minWidth: "110px",
    },
    {
      header: "Store",
      accessor: (row) => (
        <span className="text-[12px] text-slate-600 truncate font-medium">
          {row.storeRef?.storeName || row.paymentData?.storeRef?.storeName || "—"}
        </span>
      ),
      minWidth: "120px",
    },
    {
      header: 'Customer Name',
      accessor: (row) => {
        const c = row.customer || {};
        const fullName = c.customerName || c.name || '—';
        return (
          <span className="text-slate-600 !text-[12px] truncate max-w-[150px]" title={fullName}>{fullName}</span>
        );
      },
      minWidth: '150px',
    },
    {
      header: 'Contact',
      accessor: (row) => {
        const c = row.customer || {};
        const phone = c.phone || c.phoneNumber || '—';
        return (
          <span className="text-slate-600 !text-[12px]">{phone}</span>
        );
      },
      minWidth: '120px',
    },
    {
      header: 'Customer Type',
      accessor: (row) => {
        const c = row.customer || {};
        const cType = c.customerType || '—';
        return (
          <span className="text-slate-600 !text-[12px] capitalize">{cType}</span>
        );
      },
      minWidth: '120px',
    },
    {
      header: "Amount Paid",
      accessor: (row) => (
        <div className="text-emerald-600 !text-[13px] font-bold flex items-center whitespace-nowrap">
          ₹{Number(row.amount || 0).toLocaleString('en-IN')}
        </div>
      ),
      minWidth: "120px",
    },
    {
      header: "Mode of Payment",
      accessor: (row) => (
        <div className="text-slate-500 !text-[12px] font-medium flex items-center capitalize whitespace-nowrap">
          {row.paymentMethod || "—"}
        </div>
      ),
      minWidth: "130px",
    },
    {
      header: "Notes / Remarks",
      accessor: (row) => (
        <div className="text-slate-600 !text-[11px] max-w-[200px] truncate" title={row.remarks || '—'}>
          {row.remarks || "—"}
        </div>
      ),
      minWidth: "200px",
    },
    {
      header: "Action",
      accessor: (row) => (
        <div className="flex items-center justify-center whitespace-nowrap">
          <button
            onClick={() => onView && onView(row)}
            className="p-1.5 rounded-md hover:bg-slate-100 text-slate-400 hover:text-slate-700 transition-colors"
            title="View Details"
          >
            <Eye size={15} />
          </button>
        </div>
      ),
      minWidth: "60px",
    }
  ];

  const totalPages = Math.ceil((receipts?.length || 0) / limit);
  const currentData = receipts?.slice((page - 1) * limit, page * limit) || [];

  return (
    <div className="flex flex-col min-h-0 bg-white rounded-xl shadow-[0_2px_10px_-3px_rgba(6,81,237,0.1)] border border-slate-200">
      <div className="overflow-x-auto overflow-y-auto flex-1 custom-scrollbar">
        <DataTable
          columns={columns}
          data={currentData}
          emptyMessage="No records found"
          className="text-[11px]"
        />
      </div>
      {totalPages > 0 && (
        <Pagination
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};
